import Toast from '@tiger/toast';
import React from 'react';
import Loading from 'components/Loading';

Toast.config({
    Loading: ({ tip }) => <Loading tip={tip} />
});

export default Toast;
export * from '@tiger/toast';

export { Loading };
